// Add a 'scrolled' class to <html> if the page has been scrolled at all
// Using this performance method: https://stackoverflow.com/questions/41740082/scroll-events-requestanimationframe-vs-requestidlecallback-vs-passive-event-lis
(function(){
	// cache scroll state to avoid dom updates
	window.scrollstate = {
		threshold: 60,
		direction: false,
		directionTotal: 0,
		directionScrollTop: 0,
		lastScrollTop: 0,
		shouldFire: true
	};

	var checkScroll = function(){
		var diff = scrollstate.lastScrollTop - window.scrollY;
		var direction = diff == 0 ? false : (diff < 0 ? 'scrolledDown' : 'scrolledUp');
		var didTurn = direction != scrollstate.direction;
		if(didTurn) {
			scrollstate.shouldFire = true;
			scrollstate.directionTotal = Math.abs(diff);
			scrollstate.directionScrollTop = window.scrollY;
		} else {
			scrollstate.directionTotal += Math.abs(diff);
		}
		scrollstate.lastScrollTop = window.scrollY;
		scrollstate.direction = direction;

		var fire = window.scrollY == 0;
		if(scrollstate.directionTotal > scrollstate.threshold && scrollstate.shouldFire) {
			fire = true;
			scrollstate.shouldFire = false;
		}

		return fire;
	};
	var checkAndUpdateScroll = function() {
		// only update the dom if the hasScrolled state has changed 
		// and update it during an available animation frame
		if (checkScroll()) {
			requestAnimationFrame(function () {
				var html = document.getElementsByTagName('html')[0];
				html.classList.remove('false','scrolled','scrolledDown','scrolledUp');
				if(scrollstate.direction) {
					html.classList.add(scrollstate.direction);
				}
				if (window.scrollY > 0) {  html.classList.add('scrolled'); }
			});
		}
	}

	window.addEventListener('scroll', checkAndUpdateScroll);
	checkAndUpdateScroll();
})();